module.exports = __webpack_public_path__ + "img/bharatpe.6d4e095b.jpg";